import React from "react";
import { fmtPrice } from "../../../lib/format";
import { inp } from "../shared";
import { ReceiptButtons } from "../ReceiptButtons";
import { FailedPayments } from "./FailedPayments";

export function OrdersTab({ ctx }) {
  const { orders, updateOrderStatus } = ctx;
  return (
      <div>
        <h1 className="serif text-3xl mb-8">Orders</h1>
        {orders.length === 0 ? <p className="text-[#8A857D]">No orders yet.</p> : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.id} className="border border-[#262421] p-5" data-testid={`admin-order-${o.order_number}`}>
                <div className="flex flex-wrap justify-between gap-4 items-start">
                  <div>
                    <p className="serif text-lg text-[#C49A6C]">{o.order_number}</p>
                    <p className="text-xs text-[#8A857D] mt-1">{o.customer?.full_name} · {o.customer?.email} · {o.customer?.phone} · {o.customer?.emirate || o.customer?.region}</p>
                    <p className="text-xs text-[#6E685F] mt-1">{o.items.map((i) => `${i.name} ×${i.qty}`).join(", ")}</p>
                    <div className="mt-3"><ReceiptButtons number={o.order_number} /></div>
                  </div>
                  <div className="text-end">
                    <p className="text-sm">{fmtPrice(o.total, o.currency)}</p>
                    <select value={o.status} onChange={(e) => updateOrderStatus(o.id, e.target.value)} data-testid={`admin-order-status-${o.order_number}`} className={inp + " mt-2 text-xs"}>
                      <option value="pending_payment">Awaiting Payment</option>
                      <option value="paid">Paid</option>
                      <option value="processing">Processing</option>
                      <option value="shipped">Shipped</option>
                      <option value="delivered">Delivered</option>
                      <option value="cancelled">Cancelled</option>
                      <option value="returned">Returned</option>
                      <option value="refunded">Refunded</option>
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <FailedPayments />
      </div>
  );
}
